module.exports = __webpack_public_path__ + "img/apple-logo.4d4219e9.svg";